export var enUS = {
  common: {
    confrim: 'Yes',
    cancel: 'No',
    pleaseSelect: 'Please Select',
    pleaseInput: 'Please Input',
    copyrights: 'Powered by Co-Mall',
    toUpload: 'Click to Upload',
    dragToUpload: 'Click or drag file to this area to upload'
  },
  components: {
    Auth: {
      login: 'Login'
    },
    RichText: {
      tooltips: {
        header: 'header',
        bold: 'bold',
        italic: 'italic',
        underline: 'underline',
        strike: 'strike',
        blockquote: 'reference block',
        size: 'font size',
        header1: 'header 1',
        header2: 'header 2',
        listordered: 'ordered list',
        listbullet: 'bullet list',
        scriptsub: 'sub script',
        scriptsuper: 'super script',
        directionrtl: 'direction rtl',
        color: 'color',
        background: 'background color',
        font: 'font family',
        align: 'align',
        link: 'link',
        image: 'image',
        video: 'video',
        clean: 'clean style',
        'indent-1': 'return indent',
        'indent+1': 'indent',
        'code-block': 'code block'
      }
    },
    DetailView: {
      back: 'back'
    },
    Button: {
      search: 'Search',
      export: 'Export',
      cancel: 'Cancel',
      modify: 'Modify',
      create: 'Create',
      view: 'View',
      submit: 'Submit',
      delete: 'Delete',
      save: 'Save',
      select: 'Select',
      reset: 'Reset'
    },
    Table: {
      ActionColumn: {
        view: 'View',
        modify: 'Modify',
        delete: 'Delete',
        link: 'Link'
      },
      selected: 'Selected',
      loaded: 'Loaded'
    },
    Form: {
      required: ' is required'
    },
    DateRangePicker: {
      placeholder: {
        start: 'Start Date',
        end: 'End Date'
      }
    },
    DateTimeRangePicker: {
      placeholder: {
        start: 'Start Time',
        end: 'End Time'
      }
    },
    MonthRangePicker: {
      placeholder: {
        start: 'Start Month',
        end: 'End Month'
      }
    },
    TimeRangePicker: {
      placeholder: {
        start: 'Start Time',
        end: 'End Time'
      }
    },
    UploadFile: {
      moveRight: 'Move Right',
      moveLeft: 'Move Left',
      upload: 'Upload',
      uploadSuccessMessage: 'Upload Success {{success}}, Upload Failed {{error}}',
      uploadLimitSizeErrorMessage: 'Exceeded Upload Size Limit, Upload Failed',
      uploadLimitErrorMessage: 'You can only upload {{maxCount}}',
      uploadLimitText: 'Limit',
      uploadLimitUnit: 'Upload',
      preview: 'Preview'
    }
  },
  routers: {},
  loader: {},
  type: {
    arrayTreeNodeTree: {
      label: 'records',
      sum: 'total'
    }
  },
  error: {
    requestFailed: 'The request failed.',
    requestTerminated: 'The request has been terminated.'
  },
  validation: {
    number: {
      default: 'Input a valid number please.',
      integer: 'Input a valid integer please.',
      positive: 'Input a valid positive number please.',
      price: 'Input a valid price please.'
    },
    array: {
      default: 'Input a valid array please.'
    },
    boolean: {
      default: 'Input a valid boolean please.'
    },
    object: {
      default: 'Input a valid object please.'
    },
    string: {
      default: 'Input a valid string please.'
    }
  }
};